var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_8220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9979 29.9958C23.281 29.9958 29.9958 23.281 29.9958 14.9979C29.9958 6.71478 23.281 0 14.9979 0C6.71478 0 0 6.71478 0 14.9979C0 23.281 6.71478 29.9958 14.9979 29.9958Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2562 24.5691C9.51188 24.5691 4.81737 21.5509 4.72424 18.9899C4.66074 17.1697 6.85349 15.9294 11.0654 15.4129L11.1586 16.1622C7.44613 16.6194 5.42694 17.6141 5.47773 18.9645C5.54546 20.9033 9.76163 23.8156 15.2562 23.8156C15.3324 23.8156 15.4086 23.8156 15.489 23.8156C19.5951 23.7564 22.8631 22.2282 24.2769 20.7382C24.8526 20.1286 25.149 19.519 25.1278 18.973C25.0812 17.6268 22.9731 16.5601 19.4935 16.1199L19.5867 15.3706C23.5785 15.8743 25.8136 17.1443 25.8813 18.9433C25.9067 19.6968 25.5426 20.4969 24.823 21.2546C22.9647 23.2103 19.3073 24.5099 15.5017 24.5649C15.4213 24.5649 15.3409 24.5649 15.2562 24.5649V24.5691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.778 20.6152C9.71518 20.6152 6.9425 19.6035 6.82397 19.5569L7.08643 18.85C7.11606 18.8627 10.0708 19.9337 15.341 19.8533C20.607 19.7728 23.4812 18.6172 23.5109 18.6045L23.7987 19.2987C23.676 19.3495 20.7805 20.5263 15.3537 20.6067C15.159 20.6067 14.9685 20.6067 14.7822 20.6067L14.778 20.6152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3028 5.13493C14.0625 6.97633 11.6793 10.8369 11.6793 12.4074C11.6793 14.4054 13.3048 16.0309 15.3028 16.0309C17.3008 16.0309 18.9263 14.4054 18.9263 12.4074C18.9263 10.8369 16.5431 6.97633 15.3028 5.13493ZM15.3028 16.7844C12.8899 16.7844 10.9258 14.8203 10.9258 12.4074C10.9258 9.99453 14.8287 4.4915 14.9938 4.25021C15.0658 4.14862 15.1801 4.08936 15.3028 4.08936C15.4256 4.08936 15.5399 4.14862 15.6118 4.25021C15.7769 4.48727 19.6798 10.1046 19.6798 12.4074C19.6798 14.7102 17.7157 16.7844 15.3028 16.7844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0742 14.9854V14.2319C15.2986 14.2319 15.5187 14.1981 15.7261 14.1303C16.4076 13.9102 16.9326 13.3726 17.1315 12.6826L17.8554 12.89C17.5887 13.8213 16.8818 14.5537 15.9589 14.85C15.6753 14.9389 15.379 14.9854 15.0785 14.9854H15.0742Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_8220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.7ffb454e1a4dfd447c8079bc85aa29e0.svg";
export { ForwardRef as ReactComponent };